module.exports = __webpack_public_path__ + "img/SketchPnge95bd9a0d88244e2c6d09b06ced58897326dfb71014de754c0065b8fa4d748b2.26b0f548.png";